import React from 'react';

import {
  ExecutionOverrides,
} from '../components';

export function fmtExecutionOverrides(execution) {
  return <ExecutionOverrides execution={execution}/>;
}
